import _construct from "@babel/runtime-corejs3/helpers/esm/construct";
/* global global require */

var Web3 = require('web3');

var __embarkWeb3 = {};

__embarkWeb3.init = function (config) {
  global.web3 = config.web3 || global.web3; // Check if the global web3 object uses the old web3 (0.x)

  if (global.web3 && typeof global.web3.version !== 'string') {
    // If so, use a new instance using 1.0, but use its provider
    this.web3 = new Web3(global.web3.currentProvider);
  } else {
    this.web3 = global.web3 || new Web3();
  }

  global.web3 = this.web3;
};

__embarkWeb3.getInstance = function () {
  return this.web3;
};

__embarkWeb3.getAccounts = function () {
  var _this$web3$eth;

  return (_this$web3$eth = this.web3.eth).getAccounts.apply(_this$web3$eth, arguments);
};

__embarkWeb3.getNewProvider = function (providerName) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return _construct(Web3.providers[providerName], args);
};

__embarkWeb3.setProvider = function (provider) {
  return this.web3.setProvider(provider);
};

__embarkWeb3.getCurrentProvider = function () {
  return this.web3.currentProvider;
};

__embarkWeb3.getDefaultAccount = function () {
  return this.web3.eth.defaultAccount;
};

__embarkWeb3.setDefaultAccount = function (account) {
  this.web3.eth.defaultAccount = account;
};

__embarkWeb3.newContract = function (options) {
  return new this.web3.eth.Contract(options.abi, options.address);
};

__embarkWeb3.send = function () {
  var _this$web3$eth2;

  return (_this$web3$eth2 = this.web3.eth).sendTransaction.apply(_this$web3$eth2, arguments);
};

__embarkWeb3.toWei = function () {
  var _this$web;

  return (_this$web = this.web3).toWei.apply(_this$web, arguments);
};

__embarkWeb3.getNetworkId = function () {
  return this.web3.eth.net.getId();
};

export default __embarkWeb3;